var React = require('react');

function Clip (props) {
    return React.createElement("svg",props,[React.createElement("style",{"type":"text/css","key":0},"\n\t.st0{fill:#040404;}\n"),React.createElement("g",{"key":1},React.createElement("path",{"className":"st0","d":"M423.3,850c-147.1,0-191.9-125.1-195.1-191.2l0-330.1h54.9v328.8c0.7,12.8,11.2,137.6,140.2,137.6\n\t\tc128.5,0,143.1-136.6,143.6-150.7l0-504.2c-1.7-13.2-11.2-85.2-89.9-85.2c-80.3,0-85.7,74.1-85.7,82.6v520\n\t\tc0,12.8,4.3,27.6,24.9,27.6c26.8,0,29.9-22.5,30.2-27l-0.1-326.7h54.9v328.8c-2.4,33.3-27,79.9-85.1,79.9c-29,0-46.9-12-56.7-22.2\n\t\tc-23.3-23.9-23.2-57.3-23.1-61l0-519.4C336.4,89.9,368.2,0,477,0c106.8,0,140.3,89.1,144.7,136.2l0.2,1.5l-0.1,508\n\t\tC619.7,712.3,570.8,850,423.3,850z"}))]);
}

Clip.defaultProps = {"version":"1.1","id":"Warstwa_1","x":"0px","y":"0px","viewBox":"0 0 850 850","style":{"enableBackground":"new 0 0 850 850"},"xmlSpace":"preserve"};

module.exports = Clip;

Clip.default = Clip;
